import { render } from "./AddAdmin.vue?vue&type=template&id=06437f6c&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"

import "./AddAdmin.vue?vue&type=style&index=0&id=06437f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06437f6c"]])

export default __exports__